import React from 'react';
import PropTypes from 'prop-types';
import { UncontrolledTooltip } from 'reactstrap';
import { useIntl } from 'react-intl';

const CollectionsSyncedIcon = ({ collection }) => {
  const intl = useIntl();

  if (!collection.synced) {
    return null;
  }

  return (
    <span className="collection-synced-icon">
      <i
        className="fas fa-desktop"
        id={`CollectionSyncedTooltip-${collection.uuid}`}
      />
      <UncontrolledTooltip fade={false} placement="bottom" target={`CollectionSyncedTooltip-${collection.uuid}`}>
        {intl.formatMessage({ defaultMessage: 'Collection synced' })}
      </UncontrolledTooltip>
    </span>
  );
};

CollectionsSyncedIcon.propTypes = {
  collection: PropTypes.object.isRequired,
};

export default CollectionsSyncedIcon;
